/**
 * Generate a consistent color based on a string (name or email)
 */
export function getAvatarColor(str: string): string {
  const colors = [
    '#0F4FD1', // Blue
    '#31BEEF', // Cyan
    '#FF6B6B', // Red
    '#4ECDC4', // Teal
    '#95E1D3', // Mint
    '#F38181', // Pink
    '#AA96DA', // Purple
    '#FCBAD3', // Light Pink
    '#A8D8EA', // Light Blue
    '#FFD93D', // Yellow
    '#6BCF7F', // Green
    '#F97068', // Coral
  ];

  // Generate a hash from the string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use hash to pick a color
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

/**
 * Get initials from a name (max 2 characters)
 */
export function getInitials(name: string): string {
  if (!name) return '?';

  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    // Single word: take first 2 characters
    return parts[0].substring(0, 2).toUpperCase();
  }

  // Multiple words: take first character of first two words
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

/**
 * Avatar component props
 */
interface AvatarProps {
  name: string;
  size?: number;
  fontSize?: number;
}

/**
 * Generate avatar style object
 */
export function getAvatarStyle(name: string, size: number = 40, fontSize?: number): React.CSSProperties {
  return {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: getAvatarColor(name),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: 700,
    fontSize: fontSize ? `${fontSize}px` : `${size * 0.4}px`,
    userSelect: 'none',
    flexShrink: 0,
  };
}
